import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<rect x="11" y="5" width="19" height="4" rx="2"/><rect x="11" y="14" width="19" height="4" rx="2"/><rect x="11" y="23" width="19" height="4" rx="2"/><rect x="2" y="4" width="6" height="6" rx="1.5"/><rect x="2" y="13" width="6" height="6" rx="1.5"/><rect x="2" y="22" width="6" height="6" rx="1.5"/>';
export var ListSVG = function ListSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
ListSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(ListSVG);